export default class AbortError extends Error {
  reason: unknown

  constructor(reason?: unknown) {
    super('Request aborted')
    this.name = 'AbortedError'
    this.reason = reason
  }
}
